export default function FixedHeader() {
  return {
    init: () => {
      window.addEventListener(
        'scroll',
        () => {
          if (window.scrollY > 0) {
            document.documentElement.classList.add('w-is-scrolled');
          } else {
            document.documentElement.classList.remove('w-is-scrolled');
          }
        },
        { passive: true }
      );
    }
  }
}
